<template>
    <div class="consul-launch stus">
        <div class="launch-wrap marginP fl ">
            <ImageAmplify/>
            <div v-if="consultType=='ASS'" class="launch-title h42 bgc-gray">机构会诊申请单</div>
            <div v-else class="launch-title h42 ">医-医远程会诊单</div>
            <div class="launch-content" style="margin-top:10px;box-sizing: border-box;padding:0px 0px 20px 0px; ">
                <div class="launch-title1">
                    <p>基本信息</p>
                </div>
                <div style="background: #fff;border-left:1px solid #ecebea;border-right:1px solid #ecebea;">
                    <div class="number-wrap paddingL20 paddingR20 clearfix">
                        <label class="fl" style="color:#92412B">建议使用身份读卡设备</label>
                        <el-input class=" h24 launch-input " style="margin-left:10px;width:150px;"></el-input>
                        <el-button
                                size="small"
                                type="ghost"
                                style="padding:5px 15px;margin-left:10px;"
                                class="ghost-btn">检索</el-button>
                        <label class="fr">会诊费用：
                            <span class="fee-num">￥</span>
                        </label>
                    </div>
                    <div class="  consult-content-wrap">
                        <label><span class="fee-num">*</span>病人姓名</label>
                        <el-input class="w95 h24 launch-input " v-model="consulterName"></el-input>
                        <label style="margin-left:80px;"><span class="fee-num">*</span>性别</label>
                        <el-select v-model="consulterGender" size="small" style="width:100px;" class="w60 h24 launch-input">
                            <el-option label="男" value="M"/>
                            <el-option label="女" value="F"/>
                        </el-select>
                        <label style="margin-left:60px;"><span class="fee-num">*</span>年龄</label>
                        <el-input class="w44 h24 launch-input"  readonly="readonly" v-model="consulterAge"  style="width:60px;"></el-input>
                        <label style="margin-left:90px;"><span class="fee-num">*</span>患者病历号</label>
                        <el-input class="w150 h24 launch-input"   v-model="consulterInhosno"  style="width:200px;"></el-input>
                        <div class="marginT10">
                            <label><span class="fee-num">*</span>身份证</label>
                            <el-input
                                    class="w165 h24 launch-input"
                                    v-model="consulterIdcard"
                                    placeholder="请输入18位身份证号"
                                    :minlength=18
                                    :maxlength=18
                                    @blur="getAge"
                            >
                            </el-input>
                            <label style="margin-left:20px;"><span class="fee-num">*</span>电话号码</label>
                            <el-input class="w120 h24 launch-input" v-model="consulterMobile" placeholder="请输入您的电话号码" :minlength=111 :maxlength=11  @blur="getPhone"></el-input>
                            <label style="margin-left:40px;"><span class="fee-num">*</span>婚姻</label>
                            <el-select v-model="maritalStatus"
                                       :clearable="true"
                                       size="small"
                                       style="width:100px;"
                                       class="w60 h24 launch-input">
                                <el-option label="未婚" value="0"/>
                                <el-option label="已婚" value="1"/>
                                <el-option label="离异" value="2"/>
                                <el-option label="不详" value="3"/>
                            </el-select>
                            <label style="margin-left:50px;">职业</label>
                            <el-select
                                    v-model="consulterJob"
                                    size="small"
                                    :clearable="true"
                                    style="width:100px;"
                                    class="w60 h24 launch-input">
                                <el-option label="工人" value="工人"/>
                                <el-option label="农民" value="农民"/>
                                <el-option label="公务员" value="公务员"/>
                                <el-option label="学生" value="学生"/>
                            </el-select>
                        </div>
                        <div class="marginT10">
                            <label><span class="fee-num">*</span>家庭住址:</label>
                            <el-select v-model="provinceId" size="small" placeholder="请选择" @change="getProvincess"  style="width: 114px"  >
                                <el-option
                                        v-for="item in provinces"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select v-model="cityId" size="small" placeholder="请选择" @change="getEaras"  style="width: 114px">
                                <el-option
                                        v-for="item in citys"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-select v-model="regionId" size="small" placeholder="请选择"  style="width: 114px">
                                <el-option
                                        v-for="item in earas"
                                        :key="item.id"
                                        :label="item.areaName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input
                                    v-model="lxdz"
                                    style="width:212px;"
                                    size="small"
                                    placeholder="请输入详细地址"
                            ></el-input>
                        </div>
                    </div>
                </div>
                <div class="launch-title1" style="margin-top:10px;">
                <p>简要病史（申请医生填写）</p>
                 </div>
                <div style="border-left:1px solid #ecebea;border-right:1px solid #ecebea;background: #fff;box-sizing: border-box;padding:10px 0px 10px 0px;">
                    <div class="paddingL20 paddingR20">
                        <el-form  label-width="85px">
                            <span class="required-mark">*</span>
                            <el-form-item label="患者主诉：">
                                <div class="required-textarea" >
                                    <textarea type="textarea" @keyup="up1" style="box-sizing:border-box;padding:1px 0px;margin-top:3px;width:90%;height:95%;border:0;outline:none;" :maxlength=150 v-model="consultContent" class="item-text" placeholder="请输入主诉内容"/>
                                    <span class="textareaNumber">{{consultContentNumber}}/150</span>
                                </div>
                            </el-form-item>
                        </el-form>
                        <el-form  label-width="85px">
                            <span class="required-mark">*</span>
                            <el-form-item label="初步诊断：">
                                <div class="required-textarea" >
                                    <textarea type="textarea" @keyup="up2" style="box-sizing:border-box;padding:1px 0px;margin-top:3px;width:90%;height:95%;border:0;outline:none;" :maxlength=100 v-model="beforeDiagnose" class="item-text" placeholder="请输入初步诊断"/>
                                    <span class="textareaNumber">{{beforeDiagnoseNumber}}/100</span>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-form  label-width="85px" class=" paddingL20 paddingR20">
                        <span class="required-mark">*</span>
                        <el-form-item label="会诊目的：" >
                            <div class="required-textarea" >
                                <textarea type="textarea" @keyup="up3" style="box-sizing:border-box;padding:1px 0px;margin-top:3px;width:90%;height:95%;border:0;outline:none;" :maxlength=50 v-model="consultReason" class="item-text" placeholder="请输入申请会诊目的"/>
                                <span class="textareaNumber">{{consultReasonNumber}}/50</span>
                            </div>
                        </el-form-item>
                    </el-form>
                    <el-form  label-position="left"  label-width="85px" class="paddingL20 paddingR20">
                        <el-form-item label="病历资料：">
                            <div>
                                <!--<el-button size="small" type="ghost" :disabled="record" @click="linkToCx" class="ghost-btn">电子病历</el-button>-->
                            </div>
                            <div class="add-pic-list" style="margin-top:10px;">
                                <el-upload
                                        :action="uploadUrl"
                                        :data=" uploadData"
                                        :headers={sign:PasWord()}
                                        list-type="picture-card"
                                        :before-upload="beforeUpload"
                                        accept="image/gif,image/jpg,image/jpeg,image/png,image/bmp,image/jfif"
                                        :on-success="onSuccessImg"
                                        class="fl"
                                        type="select"
                                        ref="uploadRef"
                                        :file-list="imgUploadList"
                                        :on-remove="onRemoveImg"
                                        :on-preview="handlePreview">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </div>
                        </el-form-item>
                        <p class="marginT10" style="color:#afafaf;margin-left:65px;">最多可上传9张图片，支持jpg、png、gif、bmp格式</p>
                        <el-form-item label-position="right"class="marginT10">
                            <div class="ghost-btn-wrap">
                                <el-upload
                                        :action="uploadUrl"
                                        :data="uploadData"
                                        :before-upload="beforeUploadFile"
                                        :on-success="onSuccessFile"
                                        :on-remove="onRemoveFile"
                                        :file-list="fileUploadList">
                                    <el-button size="small" type="ghost" class="ghost-btn" style="color: #999999; border-color: #999999"><i class="el-icon-upload el-icon--left"></i>添加附件</el-button>
                                </el-upload>
                            </div>
                        </el-form-item>
                        <p class="marginT10" style="color:#afafaf;margin-left:65px;">仅支持pdf、xls、xlsx、doc、docx、txt、rar、zip、PDF格式，文件小于500M。</p>
                    </el-form>
                </div>
                <div class="launch-title1" style="margin-top:10px;">
                    <p>会诊申请信息</p>
                </div>
                <div style="border-left:1px solid #ecebea;border-right:1px solid #ecebea;background: #fff;box-sizing: border-box;padding:10px 0px 10px 0px;">
                    <div class=" paddingL20 paddingR20">
                        <label><span class="fee-num">*</span>申请类型：</label>
                        <el-select v-model="consultGroupType" size="small" class="launch-input h24">
                            <el-option label="名医会诊" value="名医会诊"/>
                            <el-option label="急会诊" value="急会诊"/>
                            <el-option label="多科会诊" value="多科会诊"/>
                            <el-option label="ICU会诊" value="ICU会诊"/>
                            <el-option label="护理会诊" value="护理会诊"/>
                        </el-select>
                        <label class="marginL10"><span class="fee-num">*</span>辅助诊断类型：</label>
                        <el-select v-model="auxiliaryDiagnose" size="small" class="launch-input h24 w80">
                            <el-option label="影像" value="影像"/>
                            <el-option label="病理" value="病理"/>
                        </el-select>
                    </div>
                    <div class="clearfix paddingL20 paddingR20 marginT10">
                        <div class="fl marginR10">
                            <label><span class="fee-num">*</span>会诊医院：</label>
                            <el-select
                                    v-model="hopeHosId"
                                    size="small"
                                    class="launch-input w165 h24"
                                    filterable
                                    :loading="loading"
                                    @change="getHospId"
                                    placeholder="请选择期望会诊医院">
                                <el-option v-for="item in hospList" :label="item.hosName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>会诊科室：</label>
                            <el-select
                                    v-model="hopeDeptId"
                                    size="small"
                                    class="launch-input w165 h24"
                                    filterable
                                    @visible-change="getDeptList"
                                    @change="getDeptId"
                                    :loading="loading"
                                    placeholder="请选择期望会诊科室">
                                <el-option v-for="item in deptList" :label="item.deptName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <!--<label>会诊医生(选填)：</label>-->
                            <!--<el-select-->
                                    <!--v-model="hopeDocId"-->
                                    <!--size="small"-->
                                    <!--class="launch-input w165 h24"-->
                                    <!--filterable-->
                                    <!--:loading="loading"-->
                                    <!--@visible-change="getDocList"-->
                                    <!--@change="getDocId"-->
                                    <!--placeholder="请选择医生">-->
                                <!--<el-option v-for="item in docList" :label="item.docName" :value="item.id" :key="item.id"/>-->
                            <!--</el-select>-->
                        </div>
                        <div class="fl">
                            <label>邀请会诊时间：</label>
                            <!--<input v-model="hopeTime" type="text" class="w150 h24 launch-input fontSize12" placeholder="请填写意向会诊时间"/>-->
                            <el-input v-model="hopeTime" size="small" class="launch-input h24 w150" placeholder="请填写意向会诊时间"/>
                        </div>
                    </div>
                    <div class="consul-form-item h30 consult-content-wrap" >
                        <div class="fl">
                            <label><span class="fee-num">*</span>申请机构：</label>
                            <!--<el-input class="w95 h24 launch-input " v-model="hosNames"></el-input>-->
                            <el-select
                                    v-model="initHosId"
                                    size="small"
                                    class="launch-input w165 h24"
                                    filterable
                                    :loading="loading"
                                    @change="getInitHospId">
                                <el-option v-for="item in hospList" :label="item.hosName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>申请科室：</label>
                            <el-select
                                    v-model="initDeptId"
                                    size="small"
                                    class="launch-input w165 h24"
                                    filterable
                                    @visible-change="getInitDeptList"
                                    @change="getInitDeptId"
                                    :loading="loading"
                                    placeholder="请选择申请科室">
                                <el-option v-for="item in initDeptList" :label="item.deptName" :value="item.id" :key="item.id"/>
                            </el-select>
                            <label><span class="fee-num">*</span>申请医生：</label>
                            <el-select
                                    v-model="initDocId"
                                    size="small"
                                    class="launch-input w165 h24"
                                    filterable
                                    :loading="loading"
                                    @visible-change="getInitDocList"
                                    @change="getInitDocId"
                                    placeholder="请选择申请医生">
                                <el-option v-for="item in initDocList" :label="item.docName" :value="item.id" :key="item.id"/>
                            </el-select>
                        </div>
                        <div class="fl">
                            <label>申请时间：</label>
                            <!--<input v-model="hopeTime" type="text" class="w150 h24 launch-input fontSize12" placeholder="请填写意向会诊时间"/>-->
                            <el-input v-model="showTime" size="small" readonly="readonly" class="launch-input h24 w150"/>
                        </div>
                    </div>
                </div>
                <div class="submit-btn-wrap blue-btn-wrap paddingB20" style="margin-top:30px;">
                    <el-button type="primary" class="submit-btn blue-btn h36 w200" @click="submitConsul" :loading="isSuccess">
                        提交
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.el-select-dropdown{
    height:270px;
    overflow: hidden;
}
</style>
<script>
    import { Form, FormItem,Button, Select, Option, DatePicker,Input, Message, Upload } from "element-ui";
    import axiosUtil from "../../utils/AxiosUtils.js"
    import { formatUnixTime,formatTimeStamp } from "../../utils/DateFormat.js";
    import { API_URL } from "../../data/Url";
    import { upLoadBasicParam } from "../../data/basicParam";
    import ImageAmplify from "../common/ImageAmplify.vue";
    import { imageAmplify } from "../../utils/AmplifyImage.js";
    import Vue from "vue";
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Button);
    Vue.use(Input);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(DatePicker );
    Vue.use(Upload);
    const upLoadFileCountMax = 9;//最大上传数量
    export default{
        data: function(){
            return {
                consultContentNumber:"0",
                beforeDiagnoseNumber:"0",
                consultReasonNumber:"0",
                ages:false,
                record:true,
                consulterName: "",//患者姓名
                consulterIdcard: "",//患者证件号
                consulterMobile: "",//患者手机
                consulterGender: "",//性别
                consulterAge: null,//年龄
                consulterJob: "",//患者执业
                maritalStatus:"",//患者婚姻
                consulterInhosno: "",//住院号
                consulterInhosnoType: 0,//住院号类型
                auxiliaryDiagnose: "影像",//辅助类型
                consultGroupType: "名医会诊",//会诊类型
                consultContent: "",//主诉
                consultReason: "",//会诊目的
                beforeDiagnose: "",//会诊前诊断
                hopeHosId: "",//期望医院ID
                hopeDeptId: "",//期望科室
                hopeDocId: "",//期望医生ID
                hopeTime: "",//期望时间
                showTime:"",//申请时间
                attaId: "",//附件ID
                initHosIds:"",
                hospList: [],//获取医院列表
                deptList: [],//获取科室列表
                docList: [],//获取医生列表
                loading: false,//是否正在从远程获取数据

                /*上传图片地址*/
                uploadData: {},//up-load组件的data数据
                attaIdList: [],//需要提交的附件列表
                imgUploadList: [],//需上传的图片列表
                fileUploadList: [],//需上传的文件列表
                uploadFileCount: 0,//上传的文件数量，最大为9个
                uploadUrl: API_URL,//上传图片action地址

                initHosId: "",//申请医院
                initDeptId: "",//申请科室
                initDocId: null,// 申请医生id
                initDeptList: [],// 获取申请科室列表
                initDocList: [],// 获取申请医生列表
                isSuccess: false,//是否提交成功

                identity:JSON.parse(localStorage.getItem('userInfo')).doc.docType,
                docHosIds:"",
                docIds:"",
                docDeptIds:"",
                hosNames:"",
                deptNames:"",
                docNames:"",


                provinces:[],
                citys:[],
                earas:[],
                lxdz:"",
                provinceId:"",
                cityId:"",
                regionId:""
            }
        },
        computed: {
            upLoadList: function () {//获取上传图片和文件的id
                return this.imgUploadList.concat(this.fileUploadList);
            },
            consultType: function () {//获取发起的会诊类型：ASS医助医，DOC医医
                return JSON.parse(sessionStorage.getItem("loginInfo")).doc.docType;
            }
        },
        created:function(){
            this.changeTime();
        },
        components:{
            ImageAmplify
        },
        mounted:function(){
            this.getHospList();
            this.hosNames=JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosName;
            this.docHosIds=JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId;
            if(this.identity == 'DOC'){
                this.deptNames=JSON.parse(sessionStorage.getItem("loginInfo")).doc.deptName;
                this.docNames=JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName;
                this.docDeptIds=JSON.parse(sessionStorage.getItem("loginInfo")).doc.deptId;
                this.docIds=JSON.parse(sessionStorage.getItem("loginInfo")).doc.id;
                this.initDeptList = [{"deptName":this.deptNames,"id":this.docDeptIds}];
                this.initDocList = [{"docName":this.docNames,"id":this.docIds}];
                this.initDeptId = this.docDeptIds;
                this.initDocId = this.docIds;
            }
            this.getrecord();
            this.getProvices();

        },
        methods: {
            getProvices:function(){
                let _this=this;
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:"",
                    areaLevel:1
                }
                axiosUtil(options,function(data){
                     _this.provinces=data.obj
                })
            },
            getProvincess:function(){
                let _this=this;
                _this.cityId="";
                _this.regionId="";
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.provinceId,
                    areaLevel:2
                };
                axiosUtil(options,function(data){
                    _this.citys=data.obj;
                })
            },
            getEaras:function(){
                let _this=this;
                _this.regionId="";
                let options={
                    Service:"smarthos.system.area.list",
                    areaCode:_this.cityId,
                    areaLevel:3
                }
                axiosUtil(options,function(data){
                    _this.earas=data.obj;
                })
            },
            up1:function(){
                let _this=this;
                _this.consultContentNumber=_this.consultContent.length
            },
            up2:function(){
                let _this=this;
                _this.beforeDiagnoseNumber=_this.beforeDiagnose.length
            },
            up3:function(){
                let _this=this;
                _this.consultReasonNumber=_this.consultReason.length
            },
            getrecord:function(){
                let _this=this;
            },
            linkToCx:function(){
                let _this=this;
                if(_this.consulterIdcard!=""){
        let options={
            idCard:_this.consulterIdcard,
            token: localStorage.getItem("token"),
            Service:"smarthos.book.emr.patient"
        }
        axiosUtil(options,function(data){
             if(data.list){
                 if(data.list.length>0){
                     window.localStorage.setItem("patInfo", JSON.stringify(data.list[0]));
                     window.open("./?from=ins#/linkCx");
                 }else{
                     Message({
                         showClose: true,
                         message: "该身份证号在长兴医院没有病历",
                         type: "warning"
                     });
                  }
                       }else{
                          Message({
                            showClose: true,
                            message: "该身份证号在长兴医院没有病历",
                            type: "warning"
                           });
                         }
                     })
                   }else{
                      Message({
                            showClose: true,
                            message: "请输入18位身份证号",
                            type: "warning"
                          });
                     }
            },
            getAge:function(){
                let date = new Date();
                let year = date.getFullYear();
                    if(this.consulterIdcard.length == 18){
                        var code = this.consulterIdcard.split('');
                        //∑(ai×Wi)(mod 11)
                        //加权因子
                        var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                        //校验位
                        var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                        var sum = 0;
                        var ai = 0;
                        var wi = 0;
                        for (var i = 0; i < 17; i++)
                        {
                            ai = code[i];
                            wi = factor[i];
                            sum += ai * wi;
                        }
                        var last = parity[sum % 11];
                        if(parity[sum % 11] != code[17]){
                            this.consulterIdcard="";
                            Message({
                                showClose: true,
                                message: "身份证号码输入有误，请重新输入",
                                type: "error"
                            });
                            return false;
                        }else{
                            this.consulterAge=year-this.consulterIdcard.substring(6,10);
                            if(this.consulterIdcard.substring(16,17)%2==0){
                                this.consulterGender="F";
                            }else{
                                this.consulterGender="M";
                            }
                        }
                        window.localStorage.setItem("patIdcard",this.consulterIdcard)
                    }else{
                        this.consulterIdcard="";
                        Message({
                            showClose: true,
                            message: "身份证号号码为18位",
                            type: "warning"
                        });
                    }
            },
            getPhone:function(){
                let _this=this
                if(_this.consulterMobile){
                    let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
                    if(!myreg.test(_this.consulterMobile)){
                        _this.consulterMobile="";
                        Message({
                            showClose: true,
                            message: "手机号码输入有误！",
                            type: "error"
                        });
                    }
                }
            },
            PasWord: function () {
                let options = {
                    'Service': "smarthos.system.atta.upload"
                };
                return upLoadBasicParam.sign
            },
            formatUnix: function(time){//将unix时间戳转换为yyyy-MM-dd HH:mm
        	     return formatUnixTime(time);
        	},
        	createTimeStamp: function(){//创建处理表单unix时间戳
        	    return formatTimeStamp();
        	},
            submitConsul: function(){//提交会诊单
                if(!this.initDocId){
                    Message({
                        showClose: true,
                        message: "申请医生不能为空！",
                        type: "info"
                    });
                    return;
                }
                let _this = this;
                _this.isSuccess = true;
                for(let i=0; i<_this.upLoadList.length; i++){//根据上传的附件 遍历获取attaId
                    _this.attaIdList.push(_this.upLoadList[i].response.obj.id);
                }
                if(_this.regionId==""||_this.cityId==""){
                    Message({
                        showClose: true,
                        message: "请选择省市区！",
                        type: "info"
                    });
                    _this.isSuccess = false;
                    return
                }
                let docObj = {};
                let Serviec = "";
                // switch (this.consultType){//判断是医-助-医还是医医会诊类型
                //     case "ASS":
                //         docObj = {//医-助-医
                //             hopeHosId: _this.hopeHosId,//期望医院ID
                //             hopeDeptId: _this.hopeDeptId,//期望科室
                //             hopeDocId: _this.hopeDocId,//期望医生ID
                //         };
                //         Serviec = "smarthos.consult.group.ass.issue";
                //         break;
                //     case "DOC":
                //         docObj = {//医医
                //             acceptHosId: _this.hopeHosId,//受理医院ID
                //             acceptDeptId: _this.hopeDeptId,//受理科室
                //             acceptDocId: _this.hopeDocId,//受理医生ID
                //         };
                //         Serviec = "smarthos.consult.group.doc.issue";
                //         break;
                // }
                docObj = {//医-助-医
                               hopeHosId: _this.hopeHosId,//期望医院ID
                                hopeDeptId: _this.hopeDeptId,//期望科室
                                hopeDocId: _this.hopeDocId,//期望医生ID
                            };
                Serviec = "smarthos.consult.group.ass.issue";
                let options = Object.assign({
                    consulterName: _this.consulterName,//患者姓名
                    consulterGender: _this.consulterGender,//患者性别
                    consulterIdcard: _this.consulterIdcard,//患者证件号
                    consulterMobile: _this.consulterMobile,//患者手机
                    consulterJob: _this.consulterJob,//患者执业
                    maritalStatus:_this.maritalStatus,//患者婚姻
                    consulterInhosno: _this.consulterInhosno,//患者住院号
                    consulterAddress:_this.lxdz,
                    // consulterAreaCode:_this.regionId?_this.regionId:_this.cityId,
                    consulterAreaCode:_this.regionId,
                    consultGroupType: _this.consultGroupType,//会诊类型
                    consultContent: _this.consultContent,//主诉
                    consultReason: _this.consultReason,//会诊目的
                    beforeDiagnose: _this.beforeDiagnose,//会诊前诊断
                    hopeTime: _this.hopeTime,//期望时间
                    auxiliaryDiagnose: _this.auxiliaryDiagnose,//辅助类型
                    initDocId: _this.initDocId,//发起方医生Id
                    initAssId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,//期望发起方助理
                    attaIdList: _this.attaIdList,//附件列表
                    token: localStorage.getItem("token"),
                    Service: Serviec,
                }, docObj);
                axiosUtil(options, function(data){
                    _this.isSuccess = false;
                    Message({
                        showClose: true,
                        message: "提交成功！",
                        type: "success"
                    });
                    _this.$router.go(-1);
                }, function(){//发生错误时也设置为false防止按钮一直再loading状态
                    _this.isSuccess = false;
                });
            },
            handleImageAmplify: function(index=0, ev){//图片放大
                let e = ev || event;
                let element = e.target || e.srcElement;
                let src = element.src;
                let obj = {
                    imgList: [],
                    index: 0
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(src);
            },
            getHospList: function(showList){//获取医院列表,参数未显示下拉菜单和隐藏下拉菜单的boolean，下来为true
                    this.loading = true;
                    let _this = this;
                    let options = {
                        Service: "smarthos.system.hos.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.hospList = data.list;
                        _this.initHosId=_this.docHosIds;
                    });
            },
            getHospId: function(id){//获取选择会诊的医院id
                let _this=this;
                _this.hopeHosId = id;
                this.hopeDeptId = "";// 清空已经选择的科室和医生
                this.hopeDocId = "";
            },
            getInitHospId: function(id){//获取选择申请的医院id
                let _this=this;
                _this.initHosId = id;
                if(id!=this.initHosId){
                    this.initDeptId = "";
                    this.initDocId = "";
                }

            },
            getDeptList: function(query){//获取科室列表
                if(this.hopeHosId){//如果医院已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.hopeHosId,
                        Service: "smarthos.system.dept.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.deptList = data.list;
                    });
                }else{
                   Message({
                       showClose: true,
                       message: "请先选择医院",
                       type: "info"
                   });
                }
            },
            getInitDeptList: function(query){//获取申请科室列表
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.initHosId,
                        Service: "smarthos.system.dept.list"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.initDeptList = data.list;
                    });
            },
            getDeptId: function(id){
                this.hopeDeptId = id;
                this.hopeDocId = "";
            },
            getInitDeptId: function(id){// 获取申请科室id
                if(id!=this.initDeptId) {
                    this.initDeptId = id;
                    this.initDocId = "";
                }
            },
            getDocList: function(query){//获取医生列表
                if(this.hopeDeptId){//如果医院和科室已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.hopeHosId,
                        deptId: _this.hopeDeptId,
                        Service: "smarthos.user.doc.list",
                        pageNum:1,
                        pageSize:"100"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.docList = data.list;
                    });
                }else{
                   Message({
                       showClose: true,
                       message: "请先选择科室",
                       type: "info"
                   });
                   return;
                }
            },
            getInitDocList: function(query){//获取医生列表
                if(this.initDeptId){//如果医院和科室已经选择完成则可以选择科室
                    this.loading = true;
                    let _this = this;
                    let options = {
                        hosId: _this.initHosId,
                        deptId: _this.initDeptId,
                        Service: "smarthos.user.doc.list",
                        pageNum:1,
                        pageSize:"100"
                    };
                    axiosUtil(options, function(data){
                        _this.loading = false;
                        _this.initDocList = data.list;

                    });
                }else{
                    Message({
                        showClose: true,
                        message: "请先选择科室",
                        type: "info"
                    });
                    return;
                }
            },
            getDocId: function(id){//获取选择的医生id
                this.hopeDocId = id;
            },
            getInitDocId: function(id){//获取申请的医生id
                this.initDocId = id;
            },
            changeTime: function() {//获取申请时间
                let _this = this;
                _this.timeOut = setInterval(function () {
                    _this.showTime = (new Date()).pattern("yyyy-MM-dd HH:mm");
                }, 1000);
            },
            beforeUpload: function(file){//上传图片/文件前钩子函数
                let _this = this;
                if(_this.uploadFileCount < upLoadFileCountMax){//如果上传数量小于9
                    _this.uploadFileCount++;
                    let type= file.name.replace(/.+\./,"")
                    return new Promise(function (resolve, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"IMAGE",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resolve(true);
                    });
                }else {
                    _this.uploadFileCount++;// 如果返回false，则会调用移除图片函数 ，uploadFileCount会减1
                    Message({
                       showClose: true,
                       message: "上传图片数量不能多于9张",
                       type: "info"
                    });
                    return false;
                }
            },
            beforeUploadFile: function(file){//上传文件前钩子函数
                let _this = this;
                let maxsize=1024*600;
                let type= file.name.replace(/.+\./,"")
                if(type=="RAR"||type=="pdf"||type=="xls"||type=="xlsx"||type=="doc"||type=="docx"||type=="txt"||type=="rar"||type=="zip"||type=="PDF"){
                }else{
                    Message({
                        showClose: true,
                        message:"不支持该类型文件上传",
                        type: "error"
                    })
                    return false;
                }
                if(file.size/1024>maxsize){
                    Message({
                        showClose: true,
                        message:"附件大小不能大于500mb",
                        type: "error"
                    })
                    return false;
                }else{
                    return new Promise(function (resolve, reject) {
                        _this.uploadData = Object.assign({
                            'file': file,
                            'module':'CONSULT_GROUP',
                            'fileType':"OTHER",
                            'Service': "smarthos.system.file.upload"
                        }, upLoadBasicParam);
                        resolve(true);
                    });
                }
            },
            onSuccessImg: function(response, file, fileList){//上传图片成功后钩子
                if(response.succ){
                    this.imgUploadList = fileList;
                }else {
                   Message({
                       showClose: true,
                       message: response.msg,
                       type: "error"
                   });
                }
            },
            onRemoveImg: function (file, fileList) {//删除上传图片
                if(this.uploadFileCount>0){
                    this.uploadFileCount--;
                }
                this.imgUploadList = fileList;
            },
            onSuccessFile: function(response, file, fileList){//上传文件成功后钩子
                if(response.succ){
                    this.fileUploadList = fileList;
                }else {
                   Message({
                       showClose: true,
                       message: response.msg,
                       type: "error"
                   });
                }
            },
            onRemoveFile: function (file, fileList) {//删除上传文件
                this.fileUploadList = fileList;
            },
            handlePreview: function (file) {//预览上传的图片
                let obj = {
                    imgList: [],
                    index: 0
                };
                this.$store.dispatch("getAmplifyImageArr", obj);// 储存需要放大的数组，用于左右按钮切换
                imageAmplify(file.url);
            }
        }
    }
</script>
